import { Button, ButtonProps, Stack, Text } from "@chakra-ui/react";
import { IconBase } from "components/base";
import { AddPhotoCamereIcon, PhotoHistoriesIcon } from "components/icon";
import { memo } from "react";

const ButtonCaptureProps: ButtonProps = {
  flexDirection: "column",
  width: "100%",
  maxWidth: "6.4rem",
  minHeight: "4.2rem",
  bg: "white",
  fontSize: "0.8rem",
  border: "1px solid #D4D4D4",
  color: "#525252",
  height: "auto",
  fontWeight: 500,
};

interface Props {
  isDisabled?: boolean;

  onOpenCamera: () => void;
  onSelectFile: (file: File) => void;
  onOpenPhotoHistories: () => void;
}

const ImageActions = (props: Props) => {
  const { isDisabled, onOpenCamera, onSelectFile, onOpenPhotoHistories } =
    props;

  const onClearFile = (e: React.MouseEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    const target = e.target as HTMLInputElement;
    target.value = "";
  };

  const onBeforeSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    onSelectFile(file);
  };

  return (
    <Stack gap="0.8rem">
      <Button
        {...ButtonCaptureProps}
        isDisabled={isDisabled}
        onClick={onOpenCamera}
      >
        <AddPhotoCamereIcon width="2.4rem" height="2.4rem" color="#525252" />
        <Text>再撮影</Text>
      </Button>
      <Button
        as="label"
        {...ButtonCaptureProps}
        cursor="pointer"
        isDisabled={isDisabled}
      >
        <input
          type="file"
          style={{ display: "none" }}
          disabled={isDisabled}
          accept="image/*"
          onClick={onClearFile}
          onChange={onBeforeSelectFile}
        />
        <IconBase
          icon="/img/icon-add-photo.svg"
          width="2.4rem"
          height="2.4rem"
        />
        <Text>再選択</Text>
      </Button>
      <Button
        {...ButtonCaptureProps}
        mt="auto"
        borderColor="transparent"
        backgroundColor="transparent"
        isDisabled={isDisabled}
        onClick={onOpenPhotoHistories}
      >
        <PhotoHistoriesIcon width="2.4rem" height="2.4rem" color="#525252" />
        <Text> 撮影履歴</Text>
      </Button>
    </Stack>
  );
};

export default memo(ImageActions);
